import PropTypes from "prop-types"
import React from "react"
import TextChartODD13GHGEmissionsMolecule from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsMolecule"
import TextChartODD13EnergyMixMolecule from "views/molecules/canvases/charts/TextChartODD13EnergyMixMolecule"
import ScoreLayoutOrganism from "views/organisms/scores/ScoreLayoutOrganism"
import { useAppContext } from "components/AppContext"
import { useTranslation } from "react-i18next"
import { EnergyMixKpi } from "views/atoms/charts/kpi/energyMix/EnergyMixKpi"
import DonutChartTemplate from "views/molecules/charts/template/DonutChartTemplate"
import BrokerManufBreakdown from "views/molecules/charts/brocker/BrokerManufBreakdown"
import TextChartODD13GHGEmissionsAverageMolecule from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsAverageMolecule"
import ChartODD13ConsolidateChart3 from "views/molecules/canvases/charts/ChartODD13ConsolidateChart3"

const Objective13ConsolidatedLeaserAndSoldScoreLayoutOrganism = ({ score }) => {
  const { t } = useTranslation()
  const { currentRootNode } = useAppContext()

  return (
    <ScoreLayoutOrganism
      maturity={score.odd13_maturity ?? 0}
      chart1={
        <TextChartODD13GHGEmissionsMolecule
          score={score}
          ghgEmissions={score?.odd13_CO2}
          hidePercentage={!score?.should_diplay_percentage}
        />
      }
      chart2={
        <TextChartODD13EnergyMixMolecule
          energyMixStatus={score?.odd13_energy_mix_status}
          energyMixValue={
            currentRootNode?.methodology === "bilan_carbone"
              ? Number(score?.odd13_energy_mix_value)
              : Number(score?.odd7_market_based_emission_factor)
          }
          country={EnergyMixKpi(score)}
        />
      }
      chart3={<ChartODD13ConsolidateChart3 score={score} />}
      chart4={
        <DonutChartTemplate
          title={t("score:score.13.chartEmissionBreakdownPerRegion.title")}
          data={score?.emissions_breakdown?.data}
          labelKeys={score?.emissions_breakdown?.labels}
          unitPath="units:units.emission"
          unitKey={score?.emissions_breakdown?.unit_key}
          helpText={t("score:score.13.chartEmissionBreakdownPerRegion.help")}
        />
      }
      chart5={<TextChartODD13GHGEmissionsAverageMolecule score={score} />}
      chart6={
        <BrokerManufBreakdown
          title={t(
            "score:score.13.workplace_broker.ghg_emissions_per_brand_sold.title"
          )}
          score={score?.assets_impacts}
          subKey="ghg_emissions_per_brand_sold_chart"
        />
      }
    />
  )
}

Objective13ConsolidatedLeaserAndSoldScoreLayoutOrganism.propTypes = {
  score: PropTypes.object.isRequired,
}

Objective13ConsolidatedLeaserAndSoldScoreLayoutOrganism.defaultProps = {}

export default Objective13ConsolidatedLeaserAndSoldScoreLayoutOrganism
